import { Module } from "vuex";
import { AsyncHandlerState } from "./types";
import { RootState } from "../../types";

import { getters, getterNames } from "./getters";
import { actions, actionNames } from "./actions";
import { mutations, mutationNames } from "./mutations";
import { MutationsType, GettersType, ActionsType } from "@/utils/VuexHelper";
import { AsyncHandlerResponseMessage } from "@auditcloud/shared/lib/async-handling";

const state = new AsyncHandlerState();

const namespaced: boolean = true;
const modul: Module<AsyncHandlerState, RootState> = {
  namespaced,
  getters,
  actions,
  mutations,
  state,
};

export const api = {
  namespace: "asyncHandler",
  mutations: mutationNames,
  getters: getterNames,
  actions: actionNames,
};
export type Mutations = MutationsType<typeof mutations>;
export type Getters = GettersType<typeof getters>;
export type Actions = ActionsType<typeof actions>;

export type AsyncHandlerFunctionResponse = null | AsyncHandlerResponseMessage;
export type AsyncHandlerFunction = () => Promise<AsyncHandlerFunctionResponse>;

export default modul;
